import { all, fork } from 'redux-saga/effects';

import watchCleanFilteredItems from './cleanFilteredItems';
import watchGetCategory from './getCategory';
import watchGetFilteredItems from './getFilteredItems';
import watchSetFormatViewProducts from './setFormatViewProducts';
import watchSetPaginationCategory from './setPaginationCategory';
import watchSetSearchQuery from './setSearchQuery';

function* categorySagas() {
  yield all([
    fork(watchGetCategory),
    fork(watchSetSearchQuery),
    fork(watchGetFilteredItems),
    fork(watchCleanFilteredItems),
    fork(watchSetFormatViewProducts),
    fork(watchSetPaginationCategory),
  ]);
}

export default categorySagas;
